import { useMemo, useState } from 'react';
import { screenshots } from '@/mocks/home';

const filters = ['全部', '已删', '未删', '限时可见'] as const;

const statusStyle: Record<string, string> = {
  已删: 'bg-accent-500 text-background-50',
  未删: 'bg-primary-500 text-background-50',
  限时可见: 'bg-secondary-500 text-background-50',
};

export default function ScreenshotGallery() {
  const [filter, setFilter] = useState<(typeof filters)[number]>('全部');

  const visible = useMemo(
    () => (filter === '全部' ? screenshots : screenshots.filter((s) => s.status === filter)),
    [filter],
  );

  return (
    <section
      id="screenshots"
      className="w-full bg-background-100/60 border-y border-background-200/70 py-16 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.24em] text-secondary-600">
              <span className="w-6 h-px bg-secondary-400" />
              SCREENSHOT VAULT
            </span>
            <h2 className="mt-4 font-heading font-black text-foreground-950 text-3xl md:text-4xl tracking-tight">
              原帖截图 · 未删内容
            </h2>
            <p className="mt-4 max-w-xl text-sm md:text-base leading-relaxed text-foreground-600">
              每张截图都标注了当前状态与编号。已删的、还在的、限时可见的，分开摆放，
              不混着看才不会被带偏。
            </p>
          </div>
          <div className="flex flex-wrap gap-2">
            {filters.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setFilter(f)}
                className={`px-4 py-2 rounded-full text-sm font-label whitespace-nowrap transition-colors ${
                  filter === f
                    ? 'bg-foreground-950 text-background-50'
                    : 'bg-background-50 text-foreground-700 border border-background-200 hover:bg-background-200'
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {visible.map((s, idx) => (
            <figure
              key={s.id}
              style={{ animationDelay: `${idx * 50}ms` }}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200/80 hover:border-primary-300 transition-colors ll-fade-up"
            >
              <div className="relative w-full h-72 md:h-80">
                <img
                  src={s.image}
                  alt={`${s.title} · 灵灵黑料原帖截图`}
                  title={`${s.title} 灵灵黑料 原帖截图 未删内容`}
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
                <span
                  className={`absolute top-3 left-3 px-2.5 py-1 rounded-md text-xs font-label ${
                    statusStyle[s.status]
                  }`}
                >
                  {s.status}
                </span>
                <span className="absolute bottom-3 right-3 px-2.5 py-1 rounded-md bg-foreground-950/70 backdrop-blur-sm text-xs font-label text-background-100">
                  {s.page}
                </span>
              </div>
              <figcaption className="p-5">
                <h3 className="font-heading font-bold text-foreground-950 text-base">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-2">
                  {s.caption}
                </p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}